import { create } from 'zustand';
import { IModel } from '../../../features/chat/types/model.types';
import { useChatStore } from './use-chat-store';

interface ModelStoreState {
  selectedModel: IModel | null;
  setSelectedModel: (model?: string) => void;
  openNewChatWithModel: (model: IModel) => void;
  models: IModel[];
  setModels: (models: IModel[]) => void;
}

export const useModelStore = create<ModelStoreState>((set, get) => ({
  selectedModel: null,
  models: [],
  setModels: (models) => {
    const defaultModel = models.find((model) => model.isDefaultModel) ?? null;
    set({ models });
    if (!get().selectedModel) set({ selectedModel: defaultModel });
  },
  setSelectedModel: (modelId) => {
    if (!modelId) {
      set({ selectedModel: null });
      return;
    }

    const model = get().models.find((model) => model.id === modelId) ?? null;
    set({ selectedModel: model });
  },
  openNewChatWithModel: (model) => {
    set({ selectedModel: model });
    const chatStore = useChatStore.getState();
    chatStore.setActiveConversationId(null);
  },
}));
